var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectAppContent, selectStyles } from "@adm-media/adam-store-plugin";
import { Typography, Card } from "antd";
import { BlockWrapper } from "../../wrappers/BlockWrapper/BlockWrapper";
import { useRef } from "react";
import { useAnimationClassName } from "../../../hooks/useAnimationClassName";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "./Related.scss";
import usePages from "../../../hooks/usePages";
export var Related = function (_a) {
    var _b;
    var _c = _a.viewType, viewType = _c === void 0 ? "grid" : _c, isDrawerElement = _a.isDrawerElement, title = _a.title, animation = _a.animation, props = __rest(_a, ["viewType", "isDrawerElement", "title", "animation"]);
    var contents = useSelector(selectAppContent);
    var _d = usePages(), filter = _d.filter, getMediaUrl = _d.getMediaUrl, handleLink = _d.handleLink;
    var styles = useSelector(selectStyles);
    var titleRef = useRef(null);
    var titleAnimationClass = useAnimationClassName({ ref: titleRef, animation: animation });
    var contentRef = useRef(null);
    var contentAnimationClass = useAnimationClassName({ ref: contentRef, animation: animation });
    var prevRef = useRef(null);
    var nextRef = useRef(null);
    var baseClass = "block-related";
    var modifyerClass = baseClass + (isDrawerElement ? "--drawer" : "--element");
    var blockClassName = classNames(baseClass, modifyerClass);
    var related = filter("related");
    var itemsClassNames = classNames("related__list", (_b = {},
        _b["".concat(baseClass, "__list--grid")] = viewType === "grid",
        _b["".concat(baseClass, "__list--list")] = viewType === "list",
        _b));
    var blockTitle = contents.related_title || "Related";
    var relatedCount = (related === null || related === void 0 ? void 0 : related.length) || 0;
    return relatedCount ? (_jsxs(BlockWrapper, __assign({ id: "related", style: !styles.show_related_events || !relatedCount ? { display: "none" } : undefined, className: blockClassName }, props, { "data-testid": "block-related" }, { children: [blockTitle && (_jsx(Typography.Title, __assign({ className: "".concat(baseClass, "__title ").concat(titleAnimationClass), ref: titleRef, style: { marginBottom: 20 }, level: props.titleLevel || 2 }, { children: blockTitle }))), _jsxs("div", __assign({ ref: contentRef, className: "".concat(itemsClassNames, " ").concat(contentAnimationClass) }, { children: [_jsx(Swiper, __assign({ modules: [Navigation], slidesPerView: 1, spaceBetween: 16, navigation: { prevEl: prevRef.current, nextEl: nextRef.current }, onBeforeInit: function (swiper) {
                            var nav = swiper.params.navigation;
                            if (nav && typeof nav !== "boolean") {
                                nav.prevEl = prevRef.current;
                                nav.nextEl = nextRef.current;
                            }
                        }, breakpoints: {
                            768: {
                                slidesPerView: relatedCount > 2 ? 3 : relatedCount,
                                spaceBetween: 24
                            }
                        }, className: "".concat(baseClass, "__swiper") }, { children: related === null || related === void 0 ? void 0 : related.map(function (item, index) {
                            var mediaSrc = getMediaUrl({ filter: "card_media", item: item });
                            var _a = handleLink(item, "related"), cardTitle = _a.cardTitle, handleCardClick = _a.handleCardClick;
                            return (_jsx(SwiperSlide, __assign({ className: "".concat(baseClass, "__card-wrapper") }, { children: _jsx(Card, __assign({ cover: _jsx("img", { draggable: false, alt: item.title, src: mediaSrc }), onClick: handleCardClick, style: handleCardClick ? { cursor: "pointer" } : undefined }, { children: _jsx(Card.Meta, { title: cardTitle, description: item.subtitle }) })) }), "related-item-".concat(index)));
                        }) })), _jsxs("div", __assign({ className: "".concat(baseClass, "__navigation") }, { children: [_jsx("div", { ref: prevRef, className: "swiper-button-prev" }), _jsx("div", { ref: nextRef, className: "swiper-button-next" })] }))] }))] }))) : null;
};
